var setCookie = function(cname, cvalue, milliseconds) {
    var d = new Date();
    d.setTime(d.getTime() + milliseconds);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires;
}

exports.setCookie = setCookie;

var getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);

    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

exports.getCookie = getCookie;

// var serialize = function(form) {
//     var field, s = [];
//     if (typeof form == 'object' && form.nodeName == "FORM") {
//         var len = form.elements.length;
//         for (i=0; i<len; i++) {
//             field = form.elements[i];
//             if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
//                 if (field.type == 'select-multiple') {
//                     for (j=form.elements[i].options.length-1; j>=0; j--) {
//                         if(field.options[j].selected)
//                             s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
//                     }
//                 } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
//                     s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
//                 }
//             }
//         }
//     }
//     return s.join('&').replace(/%20/g, '+');
// }
//
// exports.serialize = serialize;



// WEBPACK FOOTER //
// ./src/widgets/Common/utils.js